"use client";

import * as React from "react";
import Link from "next/link";

import { cn } from "lib/utils";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "components/ui/navigation-menu";
import clsx from "clsx";

export function LandingNavigationMenu() {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="bg-transparent">
            {"Fonctionnalités"}
          </NavigationMenuTrigger>
          <NavigationMenuContent className="bg-background">
            <ul className="grid gap-3 p-6 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr] list-none">
              <li className="row-span-3">
                <NavigationMenuLink asChild>
                  <Link
                    className="flex h-full w-full select-none flex-col justify-end rounded-md p-6 no-underline outline-none focus:shadow-md bg-gradient-to-b from-muted-50 to-muted"
                    href="/"
                  >
                    <div className="mb-2 mt-4 text-lg font-medium">
                      {"Jennyz"}
                    </div>
                    <p className="text-sm leading-tight text-muted-foreground">
                      {"Une solution complète pour gérer votre restaurant."}
                    </p>
                    <p className="text-sm leading-tight text-muted-foreground mt-1 font-medium">
                      {"De A à Z."}
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <ListItem href="#features" title="Gestion de caisse">
                {"Prise de commande, imprimer des tickets, tickets Z..."}
              </ListItem>
              <ListItem href="#features" title="Gestion des stocks">
                {"Listes de courses, réapprovisionnements..."}
              </ListItem>
              <ListItem href="#features" title="Et bien plus encore !">
                {"Vendre en ligne, programme de fidélité, rentabilité..."}
              </ListItem>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link href="#pricing" legacyBehavior passHref>
            <NavigationMenuLink
              className={clsx(navigationMenuTriggerStyle(), "bg-transparent")}
            >
              {"Prix"}
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link href="#faq" legacyBehavior passHref>
            <NavigationMenuLink
              className={clsx(navigationMenuTriggerStyle(), "bg-transparent")}
            >
              {"FAQ"}
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link href="/help" legacyBehavior passHref>
            <NavigationMenuLink
              className={clsx(navigationMenuTriggerStyle(), "bg-transparent")}
            >
              {"Documentation"}
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link href="/blog" legacyBehavior passHref>
            <NavigationMenuLink
              className={clsx(navigationMenuTriggerStyle(), "bg-transparent")}
            >
              {"Blog"}
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}

const ListItem = React.forwardRef<
  React.ElementRef<"a">,
  React.ComponentPropsWithoutRef<"a">
>(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
            className
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = "ListItem";
